import React from 'react';
import PropTypes from 'prop-types';
import handleEvent from "../../common/events/HandleEvent";
import popupWindowKeypressEventHandlerManager from './PopupWindowKeypressEventHandlerManager';
import joinClassNames from "../../common/JoinClassNames";
import commonAppSetup from "../../common/common-app-setup/CommonAppSetup";
import Components from "../../common/Components";

const propTypes = {
	// backdrop className
	backdropClassName: PropTypes.string,

	// the contents of the popup window
	children: PropTypes.node,

	// className is for the popup-window div
	className: PropTypes.string,

	// icon override for the close button
	closeIcon: PropTypes.node,

	// footer under the popup window for other buttons such as: Okay, Cancel, Save, etc...
	footerChildren: PropTypes.node,

	// callback for the backdrop getting click
	onBackdropCallback: PropTypes.func,

	// callback for the close button or user hitting esc key
	onCloseButtonCallback: PropTypes.func,

	// callback for the user pressing the enter/return key
	onEnterKeyPressed: PropTypes.func,

	//the aria-role of the popup. If nothing is supplied it will default to aria-role="alertdialog"
	role: PropTypes.string,
};

const defaultProps = {
	backdropClassName: '',
	className: '',
	closeIcon: undefined,
	footerChildren: undefined,
	onBackdropCallback: undefined,
	onCloseButtonCallback: undefined,
	onEnterKeyPressed: undefined,
	role: 'alertdialog',
};

// container popup window component that had different visual behavior based on css classes
// to close this window external to this component: update your state so that the popupwindow should not be shown and then when it rerenders it will go away
export default class PopupWindow extends React.Component {

	componentDidMount() {
		popupWindowKeypressEventHandlerManager.addEventCallback(this, this.keyPressed);
	}

	componentWillUnmount() {
		popupWindowKeypressEventHandlerManager.removeEventCallback(this);
	}

	keyPressed = e => {
		let result = true;
		// only let one popup window have a crack at this at a time; Note that popupWindowKeypressEventHandlerManager sends events in most recently registered order
		if (!e.popupWindowHasSeenThisEvent) {
			e.popupWindowHasSeenThisEvent = true;

			// if function is not defined, then return true so that it doesn't swallow the event
			if (e.keyCode === 27) {
				result = !this.props.onCloseButtonCallback || this.props.onCloseButtonCallback();
			} else if (e.keyCode === 13) {
				result = !this.props.onEnterKeyPressed || this.props.onEnterKeyPressed();
			}
		}

		return result;
	};

	handleBackdropClick = e => this.props.onBackdropCallback && this.props.onBackdropCallback(e);

	render() {
		let closeButton = undefined;
		if (this.props.onCloseButtonCallback) {
			closeButton = <a href="#" className="popup-window__close-button" onClick={handleEvent(this.props.onCloseButtonCallback)}>Close{this.props.closeIcon ? this.props.closeIcon : <svg viewBox="0 0 9.9 9.9" className="icon-close" role="presentation"><rect x="3.95" y="-1.05" width="2" height="12" transform="translate(-2.05 4.95) rotate(-45)"/><rect x="3.95" y="-1.05" width="2" height="12" transform="translate(4.95 11.95) rotate(-135)"/></svg>}</a>;
		}

		let footer = undefined;
		if (this.props.footerChildren) {
			footer = <div className="popup-window__footer">{this.props.footerChildren}</div>;
		}

		return (
			<div
				className={joinClassNames(this.props.backdropClassName, 'popup-window__backdrop', commonAppSetup.getClassName(Components.POPUP_WINDOW, 'wrapper'))}
				onClick={this.handleBackdropClick}
				role="presentation"
			>
				<div
					className={joinClassNames(this.props.className, "popup-window")}
					onClick={(e) => e.stopPropagation()}
					role={this.props.role}
				>
					<div className={joinClassNames('popup-window__content', commonAppSetup.getClassName(Components.POPUP_WINDOW, 'content'))}>
						{this.props.children}
					</div>
					{closeButton}
					{footer}
				</div>
			</div>
		);
	}
}

PopupWindow.defaultProps = defaultProps;
PopupWindow.propTypes = propTypes;
